import React, { useState } from "react";
import PriceDetails from "./PriceDetails";
import B2C2BPriceDetails from "../../pages/gd/b2c2b/B2C2BPriceDetails";
import { parsePricingTiers } from "../../utils/helpers";

const PriceTable = ({isB2C2B = false, priceCurrency = "MYR", prices, paxCount, roomTypes}: {isB2C2B?:boolean, priceCurrency: string, prices: any[], paxCount?: number, roomTypes?: Record<string, string>}) => {
  return isB2C2B ? (
    <B2C2BPriceDetails paxCount={1} priceCurrency={priceCurrency} prices={parsePricingTiers(prices)} roomTypes={roomTypes}/>
  ) : (
    <PriceDetails priceCurrency={priceCurrency} prices={prices} roomTypes={roomTypes}/>
  )
}

export default PriceTable;